import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaionlinecabbooking() {



  const cardData = {


      keyword: "Pune to Mumbai Online Cab Booking",

  headingDescription: "Trustline Travels offers convenient Pune to Mumbai online cab booking with reliable, affordable, and chauffeur-driven taxi services for business travel, airport transfers, corporate meetings, family trips, and outstation journeys. Book your cab online in just a few clicks and enjoy instant confirmation, transparent pricing, doorstep pickup, and 24/7 customer support. Our well-maintained fleet includes AC Sedans, SUVs, Ertiga, Innova Crysta, Tempo Travellers, and premium cars to suit every travel requirement. Whether you need a one-way cab or a round-trip taxi, Trustline Travels ensures a safe, comfortable, and hassle-free journey from Pune to Mumbai with experienced drivers and on-time service.",

  topPlaces: [
    {
      title: "Bandra Kurla Complex (BKC)",
      description: "BKC is Mumbai's leading financial and commercial hub, home to multinational corporations, banks, business centers, and international convention venues."
    },
    {
      title: "Andheri East",
      description: "Andheri East is a major commercial destination featuring corporate offices, premium hotels, business parks, and excellent connectivity to Mumbai Airport."
    },
    {
      title: "SEEPZ MIDC",
      description: "SEEPZ MIDC is one of India's largest technology and export processing zones, housing leading IT companies, software firms, and global businesses."
    },
    {
      title: "Nariman Point",
      description: "Nariman Point is Mumbai's prestigious business district, known for corporate headquarters, financial institutions, and luxury commercial spaces."
    },
    {
      title: "Powai Business District",
      description: "Powai is a thriving IT and commercial locality with Hiranandani Business Park, multinational companies, startups, and educational institutions."
    },
    {
      title: "NESCO Business Centre",
      description: "NESCO Business Centre hosts corporate exhibitions, international trade fairs, conferences, and major business events throughout the year."
    },
    {
      title: "Siddhivinayak Temple",
      description: "Siddhivinayak Temple is one of Mumbai's most revered Lord Ganesha temples, attracting devotees and visitors from across India."
    },
    {
      title: "Marine Drive",
      description: "Marine Drive is Mumbai's iconic coastal promenade, famous for scenic sea views, evening walks, and the spectacular Queen's Necklace skyline."
    },
    {
      title: "Bandra Fort",
      description: "Bandra Fort offers panoramic views of the Bandra-Worli Sea Link and Arabian Sea, making it a popular sightseeing destination."
    },
    {
      title: "Colaba Causeway",
      description: "Colaba Causeway is a vibrant shopping and dining destination known for fashion boutiques, local markets, cafés, and cultural attractions."
    }
  ],





"services": [
  {
    "name": "Pune to Mumbai Online Cab Booking Price",
    "description": "Check Pune to Mumbai online cab booking price with transparent fares for Sedan, Ertiga, Innova Crysta, SUVs, and premium vehicles. Book instantly with fixed pricing, no hidden charges, doorstep pickup, and professional chauffeurs. Suitable for airport transfers, business travel, family trips, and one-way or round-trip journeys."
  },
  {
    "name": "Pune to Mumbai Return Cab Fare",
    "description": "Know Pune to Mumbai return cab fare for same-day return and multi-day trips. Affordable round-trip packages include comfortable AC vehicles, experienced drivers, flexible return schedules, and transparent pricing for business, family, and leisure travel."
  },
  {
    "name": "Pune to Mumbai Taxi Fare",
    "description": "Get the latest Pune to Mumbai taxi fare with fixed pricing for Sedan, Ertiga, Innova Crysta, SUVs, and luxury cars. Our fare structure is transparent and ideal for airport transfers, corporate travel, sightseeing, and family journeys."
  },
  {
    "name": "Pune to Mumbai Affordable Fare",
    "description": "Travel with Pune to Mumbai affordable fare packages designed for budget-conscious travelers. Enjoy reliable cab service, professional chauffeurs, clean AC vehicles, and excellent customer support without compromising comfort."
  },
  {
    "name": "Pune Mumbai Online Innova Booking",
    "description": "Book Pune Mumbai Innova online for spacious and comfortable travel. Perfect for families, business executives, airport transfers, and group travel with luxury seating and generous luggage space."
  },
  {
    "name": "Pune Mumbai Online Ertiga Booking",
    "description": "Reserve Pune Mumbai Ertiga online for affordable family travel with spacious seating, AC comfort, professional drivers, and fixed pricing for one-way and round-trip journeys."
  },
  {
    "name": "Pune to Mumbai Sedan Cab Booking Online",
    "description": "Book Pune to Mumbai sedan cab online for economical travel with instant confirmation, clean AC vehicles, professional chauffeurs, and comfortable transportation for individuals and small families."
  },
  {
    "name": "Pune to Mumbai Ertiga Cab",
    "description": "Choose Pune to Mumbai Ertiga cab for family and group travel with comfortable seating, luggage capacity, affordable fares, and experienced drivers for a safe highway journey."
  },
  {
    "name": "Pune to Mumbai Innova Cab",
    "description": "Premium Pune to Mumbai Innova cab service offers spacious interiors, luxury seating, smooth highway travel, and professional chauffeurs for business travel, airport transfers, and family trips."
  },
  {
    "name": "Pune to Mumbai Online Innova Crysta Booking",
    "description": "Book Pune to Mumbai Innova Crysta online for premium intercity travel. Enjoy luxury interiors, extra luggage space, comfortable seating, and reliable chauffeur service for airport and corporate travel."
  },
  {
    "name": "Toyota Innova Crysta Car Hire Pune",
    "description": "Toyota Innova Crysta car hire in Pune provides premium transportation for Mumbai airport transfers, business meetings, weddings, family vacations, and long-distance travel with experienced drivers."
  },
  {
    "name": "Toyota Innova Ertiga Car Booking",
    "description": "Book Toyota Innova or Ertiga cars for comfortable Pune to Mumbai travel. Select the vehicle that best suits your passenger count, luggage requirements, and travel budget."
  },
  {
    "name": "Pune to Mumbai Sedan Cab Service Online Booking",
    "description": "Book Pune to Mumbai sedan cab service online with instant confirmation, fixed pricing, professional drivers, and comfortable AC vehicles for smooth intercity transportation."
  },
  {
    "name": "Pune to Mumbai Cab Round Trip",
    "description": "Reserve Pune to Mumbai cab round trip with flexible return schedules for business meetings, family visits, sightseeing, and corporate travel using comfortable and well-maintained vehicles."
  },
  {
    "name": "Best Cab Service Pune to Mumbai",
    "description": "Choose the best cab service Pune to Mumbai with affordable pricing, experienced chauffeurs, premium vehicles, transparent billing, and reliable 24x7 customer support."
  },
  {
    "name": "Pune to Mumbai 24x7 Online Cab Booking",
    "description": "Book Pune to Mumbai cab online anytime with our 24x7 booking service. Instant confirmation, multiple vehicle choices, professional drivers, and reliable customer support ensure hassle-free travel."
  },
  {
    "name": "Pune to Mumbai Airport Cab Service",
    "description": "Reliable Pune to Mumbai Airport cab service offering direct transfers to all airport terminals with timely pickups, luggage assistance, flight monitoring, and comfortable AC vehicles."
  },
  {
    "name": "Pune Airport to Mumbai Cab",
    "description": "Book Pune Airport to Mumbai cab for direct transportation from Pune Airport to any location in Mumbai with professional chauffeurs, fixed fares, and comfortable travel."
  },
  {
    "name": "Pune Airport to Mumbai Airport Cab",
    "description": "Pune Airport to Mumbai Airport cab service provides fast and convenient airport-to-airport transfers with flight tracking, punctual pickups, and experienced drivers."
  },
  {
    "name": "Pune to Mumbai Velocity Cabs Online Cab Booking",
    "description": "Book Pune to Mumbai Velocity Cabs online for one-way, round-trip, airport transfer, and corporate travel with transparent pricing, clean vehicles, and dependable chauffeur service."
  },
  {
    "name": "Pune to Mumbai Online Cab Booking",
    "description": "Reserve Pune to Mumbai online cab booking with instant confirmation, multiple vehicle options, affordable pricing, and secure booking for business, family, and airport travel."
  },
  {
    "name": "Pune to Mumbai Online Taxi",
    "description": "Book Pune to Mumbai online taxi for convenient intercity transportation with fixed pricing, experienced chauffeurs, and comfortable AC vehicles available throughout the day."
  },
  {
    "name": "Pune to Mumbai Online Cab Service",
    "description": "Our Pune to Mumbai online cab service offers one-way, airport, and round-trip bookings with transparent fares, quick confirmations, and professional drivers."
  },
  {
    "name": "Book Pune to Mumbai Cab Online",
    "description": "Book Pune to Mumbai cab online in minutes with secure reservations, flexible pickup schedules, transparent pricing, and multiple vehicle categories to suit every travel need."
  },
  {
    "name": "Pune to Mumbai Taxi Booking Online",
    "description": "Reserve Pune to Mumbai taxi online with easy booking, instant confirmation, affordable fares, and professional chauffeur service for reliable intercity transportation."
  },
  {
    "name": "Pune Mumbai Car Hire",
    "description": "Book Pune Mumbai car hire for business travel, family trips, airport transfers, and sightseeing with Sedan, Ertiga, Innova Crysta, SUVs, and luxury vehicles."
  },
  {
    "name": "Pune to Mumbai Car Hire",
    "description": "Professional Pune to Mumbai car hire service offering safe, comfortable, and affordable travel with experienced chauffeurs and well-maintained vehicles."
  },
  {
    "name": "Car Hire from Pune to Mumbai",
    "description": "Hire a private car from Pune to Mumbai for airport transfers, corporate travel, family vacations, and one-way or round-trip journeys with transparent pricing."
  },
  {
    "name": "Pune to Mumbai Car Rentals",
    "description": "Choose Pune to Mumbai car rentals for flexible travel packages including one-way, airport, sightseeing, and business travel with multiple vehicle options."
  },
  {
    "name": "Online Cab Booking Pune to Mumbai",
    "description": "Online cab booking Pune to Mumbai offers instant reservation, fixed fares, secure payment options, professional drivers, and comfortable AC vehicles available 24x7."
  },
  {
    "name": "Pune to Mumbai One Way Cab Online",
    "description": "Book Pune to Mumbai one way cab online and pay only for your single journey. Ideal for airport transfers, business meetings, and personal travel with transparent pricing."
  },
  {
    "name": "Cheap Pune to Mumbai Online Cab",
    "description": "Cheap Pune to Mumbai online cab service provides budget-friendly transportation with clean vehicles, experienced chauffeurs, and fixed fares without compromising safety or comfort."
  },
  {
    "name": "Best Pune Mumbai Car Hire Service",
    "description": "Experience the best Pune Mumbai car hire service with premium vehicles, transparent pricing, reliable chauffeurs, instant online booking, and 24x7 customer assistance."
  },
  {
    "name": "Pune Mumbai Taxi Booking",
    "description": "Book Pune Mumbai taxi with quick online confirmation, affordable fares, professional drivers, and multiple vehicle options for one-way, airport, and round-trip travel."
  },
  {
    "name": "24x7 Pune to Mumbai Online Cab Service",
    "description": "Our 24x7 Pune to Mumbai online cab service ensures reliable transportation anytime with instant booking, experienced drivers, clean AC vehicles, and dependable customer support."
  }
],

"tableData": [
  ["Pune to Mumbai Online Cab Booking Price", "Pune to Mumbai Return Cab Fare"],
  ["Pune to Mumbai Taxi Fare", "Pune to Mumbai Affordable Fare"],
  ["Pune Mumbai Online Innova Booking", "Pune Mumbai Online Ertiga Booking"],
  ["Pune to Mumbai Sedan Cab Booking Online", "Pune to Mumbai Ertiga Cab"],
  ["Pune to Mumbai Innova Cab", "Pune to Mumbai Online Innova Crysta Booking"],
  ["Toyota Innova Crysta Car Hire Pune", "Toyota Innova Ertiga Car Booking"],
  ["Pune to Mumbai Sedan Cab Service Online Booking", "Pune to Mumbai Cab Round Trip"],
  ["Best Cab Service Pune to Mumbai", "Pune to Mumbai 24x7 Online Cab Booking"],
  ["Pune to Mumbai Airport Cab Service", "Pune Airport to Mumbai Cab"],
  ["Pune Airport to Mumbai Airport Cab", "Pune to Mumbai Velocity Cabs Online Cab Booking"],
  ["Pune to Mumbai Online Cab Booking", "Pune to Mumbai Online Taxi"],
  ["Pune to Mumbai Online Cab Service", "Book Pune to Mumbai Cab Online"],
  ["Pune to Mumbai Taxi Booking Online", "Pune Mumbai Car Hire"],
  ["Pune to Mumbai Car Hire", "Car Hire from Pune to Mumbai"],
  ["Pune to Mumbai Car Rentals", "Online Cab Booking Pune to Mumbai"],
  ["Pune to Mumbai One Way Cab Online", "Cheap Pune to Mumbai Online Cab"],
  ["Best Pune Mumbai Car Hire Service", "Pune Mumbai Taxi Booking"],
  ["24x7 Pune to Mumbai Online Cab Service", ""]
],






whychoose: [
  {
    WhyChooseheading: "Easy Pune to Mumbai Online Cab Booking",
    WhyChoosedescription: "Trustline Travels offers a simple and convenient online cab booking service for comfortable travel from Pune to Mumbai."
  },
  {
    WhyChooseheading: "Instant Booking Confirmation",
    WhyChoosedescription: "Get quick confirmation for your Pune to Mumbai cab with fast response and hassle-free reservation assistance."
  },
  {
    WhyChooseheading: "Affordable Online Cab Rates",
    WhyChoosedescription: "Book your cab at competitive prices with transparent fare details and no hidden booking charges."
  },
  {
    WhyChooseheading: "Comfortable Fleet for Every Journey",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers based on your travel requirements."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "Enjoy convenient pickup from homes, hotels, offices, Pune Airport, railway stations, and nearby locations."
  },
  {
    WhyChooseheading: "Safe & Experienced Drivers",
    WhyChoosedescription: "Our professional chauffeurs ensure a smooth, secure, and comfortable journey via the Mumbai-Pune Expressway."
  },
  {
    WhyChooseheading: "Suitable for Business & Leisure Travel",
    WhyChoosedescription: "Whether you're heading for corporate meetings, airport transfers, family visits, or vacations, we have the perfect cab for you."
  },
  {
    WhyChooseheading: "Customer Support Throughout the Booking",
    WhyChoosedescription: "Our dedicated team is always available to assist you with online booking, fare details, and travel-related queries."
  }
]

};

const faqData = [
  {
    question: "Can I book a Pune to Mumbai cab online with Trustline Travels?",
    answer: "Yes, Trustline Cab provides easy online cab booking for Pune to Mumbai with quick confirmation and reliable service."
  },
  {
    question: "Is online cab booking available 24/7?",
    answer: "Yes, you can book your Pune to Mumbai cab anytime as our booking assistance is available throughout the day."
  },
  {
    question: "Which vehicles can I book online?",
    answer: "You can book Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers according to your travel needs."
  },
  {
    question: "Do you offer one-way online cab booking?",
    answer: "Yes, we provide both one-way and round-trip online cab booking options from Pune to Mumbai."
  },
  {
    question: "How much does Pune to Mumbai online cab booking cost?",
    answer: "The fare depends on the selected vehicle, travel date, and trip type. Contact us for an instant quotation."
  },
  {
    question: "Do you provide online booking for Mumbai Airport transfers?",
    answer: "Yes, you can easily book online cabs for Mumbai Airport Terminal 1 and Terminal 2 transfers."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless mentioned during booking."
  },
  {
    question: "Can I schedule my cab in advance through online booking?",
    answer: "Yes, advance online booking is available and recommended for guaranteed vehicle availability."
  },
  {
    question: "Will I receive booking confirmation immediately?",
    answer: "Yes, once your booking details are confirmed, our team provides prompt booking confirmation."
  },
  {
    question: "How can I complete Pune to Mumbai online cab booking with Trustline Travels?",
    answer: "Simply share your pickup location, destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vivek Kulkarni",
    feedback: "Booking my Pune to Mumbai cab online with Trustline Travels was quick and convenient. The confirmation was immediate, the driver arrived on time, and the entire journey was smooth and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Rachana Patil",
    feedback: "The online booking process was simple and hassle-free. Trustline Travels provided excellent customer support, a clean vehicle, and a pleasant travel experience from Pune to Mumbai.",
    rating: 5
  }
];














  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Online Cab Booking",
  "image": "https://www.trustlinetravels.com/assets/images/pune-to-mumbai-online-cab-booking.webp",
  "description": "Book Pune to Mumbai online cab booking with Trustline Travels for safe, comfortable, and affordable travel. Choose from Sedan, Ertiga, Innova, Innova Crysta, SUV, and luxury cabs for one-way, round-trip, and Mumbai Airport transfers with 24x7 service.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/pune-to-mumbai-online-cab-booking"
  }
};





  return (
    <div>
<Helmet>
  <title>Pune to Mumbai Online Cab Booking | 24x7 Taxi Service | +91 8087080034</title>

  <meta
    name="description"
    content="Book Pune to Mumbai online cab booking at affordable fares with Trustline Travels. Reserve Sedan, Ertiga, Innova, Innova Crysta, SUV, and luxury taxis for one-way, round-trip, and Mumbai Airport transfers with instant confirmation and 24x7 service."
  />

  <meta
    name="keywords"
    content="Pune to mumbai online cab booking price, pune to mumbai return cab fare, pune to mumbai taxi fare, pune to mumbai affordable fare, pune mumbai online innova booking, pune mumbai online ertiga booking, pune to mumbai sedan cab booking online, pune to mumbai ertiga cab, Pune to Mumbai Innova Cab, pune to mumbai online innova crysta booking, Toyota Innova Crysta Car Hire Pune, toyota innova ertiga car booking, pune to mumbai sedan cab service online booking, pune to mumbai cab round trip, best cab service pune to mumbai, pune to mumbai 24x7 online cab booking, Pune to Mumbai Airport cab service, pune airport to mumbai cab, pune airport to mumbai airport"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/35.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaionlinecabbooking;